import { Theme } from "@emotion/react";
import { KonturColors } from "@skbkontur/colors";

import { defaultThemeTokens } from "./DefaultCandyTheme";
import { buildTheme, overrideTheme } from "./ThemeBuilder/BuildTheme";
import { overrideThemeTokens } from "./ThemeBuilder/ThemeTokens";

export const diadocCandyTheme: Theme = {
    candy: overrideTheme(
        buildTheme(
            overrideThemeTokens(defaultThemeTokens, {
                colors: {
                    blackAndWhite: {
                        primaryBackgroundColor: "#ffffff",
                    },
                    semantic: {
                        action: {
                            backgroundColor: KonturColors.greenMint10,
                            color: KonturColors.greenMint90,
                            alternativeColor: KonturColors.greenMint80,
                        },
                    },
                    brand: {
                        primaryColor: KonturColors.greenMintLightBasic50,
                        panelColor: KonturColors.greenMint90,
                    },
                },
            })
        ),
        {
            cardActualInfo: {
                linkColor: KonturColors.greenMint70,
            },
        }
    ),
};
